import React from "react";
import Subscriber from "../../subscriber.class";
import Settings from "../../services/settings.service";
import Storage from "../../services/storage.service";
import {getStepStyleByPath, getRouteObsrv} from "../../services/flow.service";
import CartButton from "./cart";
import white_logo from "../../assets/img/new_onboarding/atoms-logo-white.svg";
import red_logo from "../../assets/img/new_onboarding/atoms-logo-original.svg";

export default class Header extends Subscriber {
  state = {
    header_visible: true,
    variation: "vmo-plain-header",
  };

  componentDidMount() {
    this.subscriptions.push(
      Storage.get_obsrv("modal_open").subscribe((modal_type) => {
        this.setState({
          header_visible: modal_type !== "full-mobile",
        });
      })
    );

    this.subscriptions.push(
      Storage.get_obsrv("ready").subscribe((ready) => {
        this.setState({
          ready: ready
        });
      })
    );

    getRouteObsrv().subscribe((data) => {
      this.setState({
        variation: getStepStyleByPath(data)
      });
    });
  }

  render() {
    if (!this.state.header_visible) {
      return "";
    }

    let logo = <img alt="" className="vmo-blink" src={red_logo} />;
    if(this.state.ready && this.state.variation !== "vmo-plain-header"){
      logo = <img alt="" className="vmo-blink" src={white_logo} />;
    }

    return (
      <div className="vmo-header-wrapper">
        <div className="vmo-header">
          <div className="vmo-centered-max vmo-header-padded">
            <div className="vmo-header-flex">
              <div className="vmo-brand-logo vmo-header-flex-1">
                <a href={Settings.logo_link}>{logo}</a>
              </div>
              <div className="vmo-header-flex-2">
                <CartButton />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
